// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"8ba90f60","239":"05d1037d","455":"dc3f99f7","977":"6bff10e1"}[chunkId] + ".chunk.js";
};